import React from 'react';
import PropTypes from 'prop-types';

import { DODGER_BLUE } from '@constant/colors';

const Valid = ({ className, color }) => (
  <svg className={className} viewBox="0 0 13 13">
    <path
      stroke={color}
      strokeWidth="2.057"
      d="M3 6.888L6.16 10.2 11 3"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Valid.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

Valid.defaultProps = {
  color: DODGER_BLUE,
};

export default Valid;
